import * as types from './transcripts.types';
import * as constants from './transcripts.constants';
import { ISession } from '../../resource/session/session.types';

export const initialSessionTranscriptPageAction = (): types.IInitialSessionTranscriptPageAction => ({
  type: constants.INITIAL_SESSION_TRANSCRIPT_PAGE,
});

export const fetchSessionTranscriptAction = (
  sessionId: ISession['id'],
  params?: types.IFetchSessionTranscriptActionParams,
): types.IFetchSessionTranscriptAction => ({
  type: constants.FETCH_SESSION_TRANSCRIPT,
  payload: { sessionId, params },
});

export const storeSessionTranscript = (transcripts: types.ISessionTranscript): types.IStoreSessionTranscript => ({
  type: constants.STORE_SESSION_TRANSCRIPT,
  payload: transcripts,
});

export const clearSessionTranscript = (): types.IClearSessionTranscript => ({
  type: constants.CLEAR_SESSION_TRANSCRIPT,
});

export const fetchSessionTranscriptSummaryAction = (
  sessionId: ISession['id'],
): types.IFetchSessionTranscriptSummaryAction => ({
  type: constants.FETCH_SESSION_TRANSCRIPT_SUMMARY,
  payload: { sessionId },
});
